<template>
  <div>
    <div v-if="anyUserOrganizationsAvailable">
      <div v-if="workerCheck">
        <v-card
          small
          color="transparent"
          class="mt-3 project-card"
          elevation="0"
        >
          <div class="filter-style">
            <v-btn
              color="#37474F"
              outlined
              class="next-style"
              elevation="0"
              @click="showModal = true"
            >
              Filter
            </v-btn>&nbsp;&nbsp;
            <v-btn
              dark
              fab
              outlined
              icon
              color="#37474F"
              small
              @click="clearFilter()"
            >
              <v-icon
                small
                dark
              >
                mdi-filter-off
              </v-icon>
            </v-btn>
          </div>

          <v-row>
            <v-col>
              <div
                v-if="!anyInvoicesAvailable"
                class="empty-alert-div mt-5"
              >
                <v-card
                  color="#FFF"
                  elevation="0"
                >
                  <br>
                  <br>
                  <p class="empty-alert-msg">
                    <v-icon
                      size="25"
                      color="#C62828"
                    >
                      mdi-information-outline
                    </v-icon>
                    No Invoices Found
                  </p>
                  <br>
                  <br>
                </v-card>
              </div>
              <div
                v-else
                class="container-box"
              >
                <div
                  v-for="item in draftInvoices"
                  :key="item.id"
                  class="box mt-5"
                >
                  <v-card-text>
                    <v-row>
                      <v-col cols="9">
                        <p class="title-text">
                          {{ item.job.name }}
                        </p>
                        <span class="value-text-style">
                          <font class="date-style">
                            Issued Date : {{ item.issue_date }}
                          </font>
                        </span>
                      </v-col>
                      <v-col cols="3">
                        <font
                          v-if="isSiteManager"
                          class="money-style"
                        >
                          $ {{ formatnumber(item.amount) }}
                        </font>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <hr>
                  <v-card-actions>
                    <v-btn
                      x-small
                      elevation="0"
                      color="#37474F"
                      outlined
                      class="more-btn"
                      @click="invoiceDetails(item.id)"
                    >
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-card-actions>
                </div>
                <div
                  ref="observer"
                  class="observer"
                />
                <div class="text-center">
                  <v-progress-circular
                    v-if="lazyLoader"
                    size="25"
                    :width="1"
                    color="#E2E2E2"
                    indeterminate
                  />
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <div
        v-else
        class="empty-alert-div mt-5"
      >
        <v-card
          color="#FFF"
          elevation="0"
        >
          <br>
          <br>
          <p class="empty-alert-msg">
            <v-icon
              size="25"
              color="#C62828"
            >
              mdi-information-outline
            </v-icon>
            You don't have permission to view this resource
          </p>
          <br>
          <br>
        </v-card>
      </div>
    </div>
    <div
      v-else
      class="empty-alert-div mt-5"
    >
      <v-card
        color="#FFF"
        elevation="0"
      >
        <br>
        <br>
        <p class="empty-alert-msg">
          <v-icon
            size="25"
            color="#C62828"
          >
            mdi-information-outline
          </v-icon>
          No Organizations found
        </p>
        <br>
        <br>
      </v-card>
    </div>
    <filter-invoice
      v-if="showModal"
      :show-status="showStatus"
      :filter-type="filterType"
      @success="filteredData"
      @closed="showModal = false"
    />
    <centre-spinner :loading="loading" />
  </div>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import FilterInvoice from './InvoiceFilter.vue';
import moment from 'moment';
export default {
  name: 'DraftInvoices',
  components: {
    'centre-spinner': spinner,
    'filter-invoice': FilterInvoice,
  },
  filters: {
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    statusUpdate (val) {
      if (val === true) {
        return 'Active*';
      }
      return 'Expired';
    },
    convertToLocal (stringDatetime) {
      return moment(stringDatetime).local().format('Do MMMM YYYY');
    },
  },
  data: () => ({
    loading: false,
    showModal: false,
    showStatus: false,
    lazyLoader: false,
    startPage: 0,
    observer: null,
    filterType: 'draft',
  }),
  computed: {
    userOrganizations () {
      return this.$store.getters['organization/getUserOrganizations'];
    },
    anyUserOrganizationsAvailable () {
      if (this.userOrganizations.length !== 0) {
        return true;
      }
      return false;
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    draftInvoices () {
      return this.$store.getters['invoice/getDraftInvoices'];
    },
    anyInvoicesAvailable () {
      if (this.draftInvoices.length === 0) {
        return false;
      }
      return true;
    },
    preDraftInvoiceFilters () {
      return this.$store.getters['invoice/getDraftInvoiceFilters'];
    },
    workerCheck () {
      return (
        this.anyUserOrganizationsAvailable &&
        this.selectedOrganization.app_user_role !== 'worker'
      );
    },
    isSiteManager () {
      return this.selectedOrganization.app_user_role === 'site-manager';
    },
  },
  async mounted () {
    this.loading = true;
    await this.clearDraftInvoices();
    await this.getUserOrganizations();
    this.workerCheck && (await this.getAllDraftInvoices());
    this.workerCheck && (await this.loadMore());
  },
  methods: {
    async getUserOrganizations () {
      this.loading = true;
      await this.$store
        .dispatch('organization/fetchUserOrganizations', {
          params: {
            requestStatus: 'accepted',
          },
        })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getColor (val) {
      if (val === 'active') {
        return '#2E7D32';
      }
      return '#C62828';
    },
    formatnumber (number) {
      const unitlist = ['', 'K', 'M', 'B'];
      const sign = Math.sign(number);
      let unit = 0;
      while (Math.abs(number) >= 1000) {
        unit = unit + 1;
        number = Math.floor(Math.abs(number) / 100) / 10;
      }
      return sign * Math.abs(number) + unitlist[unit];
    },
    async getAllDraftInvoices () {
      await this.$store
        .dispatch('invoice/fetchDraftInvoices', {
          orgExtId: this.selectedOrganization.organization.external_id,
          params: {
            params: {
              status: ['draft'],
              startPage: 0,
              limit: 5,
            },
          },
        })
        .then(() => {
          this.startPage += 5;
          this.this.loadMore();
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async getDraftInvoices () {
      this.lazyLoader = true;
      await this.$store
        .dispatch('invoice/fetchDraftInvoices', {
          orgExtId: this.selectedOrganization.organization.external_id,
          params: {
            params: {
              from:
                this.preDraftInvoiceFilters.startDate !== undefined
                  ? this.preDraftInvoiceFilters.startDate
                  : null,
              to:
                this.preDraftInvoiceFilters.endDate !== undefined
                  ? this.preDraftInvoiceFilters.endDate
                  : null,
              jobId:
                this.preDraftInvoiceFilters.jobId !== undefined
                  ? this.preDraftInvoiceFilters.jobId
                  : null,
              status: ['draft'],
              startPage: this.startPage,
              limit: 5,
            },
          },
        })
        .then(() => {
          this.startPage += 5;
          this.lazyLoader = false;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    async clearFilter () {
      this.startPage = 0;
      await this.$store.dispatch('invoice/saveDraftInvoiceFilters', {});
      await this.clearDraftInvoices();
      await this.getAllDraftInvoices();
      await this.loadMore();
    },
    async loadMore () {
      if (this.draftInvoices.length === 0) {
        return;
      }
      await this.initObserver();
    },
    initObserver () {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: 0.5,
      };
      this.observer = new IntersectionObserver(this.handleIntersect, options);
      this.observer.observe(this.$refs.observer);
    },
    handleIntersect (entries) {
      if (entries[0].isIntersecting) {
        this.getDraftInvoices();
      }
    },
    clearDraftInvoices () {
      this.$store.dispatch('invoice/clearDraftInvoices');
    },
    async filteredData () {
      this.startPage = 0;
      await this.clearDraftInvoices();
      await this.getDraftInvoices();
      await this.loadMore();
    },
    invoiceDetails (id) {
      this.loading = true;
      setTimeout(() => {
        this.$router.push({ path: `invoices/${id}/details` });
      }, 1000);
    },
  },
};
</script>

<style scoped>
.time-style {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px;
}

p {
  margin-bottom: 0px !important;
}

.time-style .value-text-style {
  font-size: 12px;
}

.box {
  /* padding-bottom: 7px; */
  width: 100% !important;
  background-color: #FFF;
  border-radius: 10px;
}

.theme--dark.v-list {
  background-color: white !important;
}

.theme--dark >>> .v-list-item {
  color: #37474f !important;
}

.v-progress-circular {
  margin: 1rem;
}

.text-white {
  color: white;
}

.rounded {
  border-radius: 10px !important;
}

.subheader-style {
  font-size: 14px;
}

.title-text {
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
}

.value-text-style {
  font-size: 12px;
}

.project-card {
  border-radius: 0px !important;
  padding: 0px !important;
}

.btn-sm {
  height: 20px !important;
}

.short-letter-style {
  color: white;
}

.observer {
  height: 40px;
}

.col-2 {
  padding-right: 0px;
  padding-left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.col-3 {
  padding-right: 0px;
  padding-left: 0px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.date-style {
  font-weight: 500;
}

.status-style {
  font-weight: 500;
  text-transform: capitalize;
}

.money-style {
  color: green;
  font-weight: bold;
}

.next-style {
  font-size: 12px;
  width: 80px;
  font-weight: lighter !important;
  text-transform: none !important;
}

.filter-style {
  text-align: right;
  padding-top: 10px;
  padding-bottom: 10px;
}

.more-btn {
  border: none !important;
  padding-top: 0px;
}

.empty-alert-msg {
  padding: 12px;
}

.v-card__actions {
  justify-content: flex-end !important;
}

hr {
  border-color: #cccccc3d;
}
</style>
